import styled from 'styled-components';
import { device } from '../../constants/styles';
import { token } from '@bynder/design-system';

interface SectionProps {
  $backgroundColor?: string;
  $backgroundImage?: string;
  $height?: number;
  $css?: string;
  $isFirst?: boolean;
  $isActiveSection?: boolean;
  $isUploadingInProgress: boolean;
  $isTypographyPickerOpen: boolean;
}

export const StyledSection = styled.li<SectionProps>`
  background-color: ${({ $backgroundColor, $isUploadingInProgress }) =>
    $isUploadingInProgress ? token.gray100 : $backgroundColor || 'transparent'};
  ${({ $backgroundImage }) =>
    $backgroundImage && `background-image: url(${$backgroundImage})`};
  background-size: cover;
  flex: 0 1 auto;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  position: relative;
  min-height: ${props => (props.$height ? `${props.$height}px` : `auto`)};
  padding-top: ${({ $isFirst, $isActiveSection }) =>
    $isFirst && $isActiveSection ? '70px' : '0px'};
  transition: padding-top 0.3s ease-in-out;
  pointer-events: ${props => (props.$isTypographyPickerOpen ? 'none' : 'auto')};
  @media ${device.tablet} {
    padding-right: 0;
    padding-left: 0;
  }
  &&& {
    ${props => props.$css}
  }
`;
